import React, { useState } from "react";
import BusinessSubNav from "../../components/Business/BusinessSubNav/BusinessSubNav";
import BusinessTitleSection from "../../components/Business/BusinessTitleSection/BusinessTitleSection";
import { Responsive } from "../../interface/redux/config";
import { useLanguage } from "../../hooks/useLanguage";

type Props = {
  Desktop: Responsive;
  PcTablet: Responsive;
  Mobile: Responsive;
};

const Odm = ({ Desktop, PcTablet, Mobile }: Props) => {
  const { isKr } = useLanguage();
  const [NavIndex, setNavIndex] = useState<number | undefined>(undefined);
  const Nav_layout = isKr
    ? ["운용모델", "진행절차", "구축 후 효과"]
    : ["Operation Model", "Process", "Post-Implementation Effects"];
  return (
    <main className="bg-black">
      <BusinessTitleSection
        Desktop={Desktop}
        PcTablet={PcTablet}
        Mobile={Mobile}
        tag="HUCONN BUSINESS | ODM"
        title={`ODM`}
        sub={isKr ? `아이디어 제품 형상화, 시제품 제작 지원` : `Idea product visualization, prototype production support`}
        mb={isKr ? `아이디어 제품 형상화, 시제품 제작 지원` : `Idea product visualization, prototype production support`}
        bgstyle="pc:bg-odm-title-pc tablet:bg-odm-title-tablet mb:bg-odm-title-mb"
      />
      <BusinessSubNav
        layout={Nav_layout}
        nowNav={NavIndex !== undefined ? NavIndex : 0}
        setNav={setNavIndex}
      />
    </main>
  );
};

export default Odm;
